import { useLang } from "@/i18n/LanguageContext";
import AlgorithmCard from "@/components/results/AlgorithmCard";

const ORDER = [
  "glucose",
  "cholesterol",
  "vitaminD",
  "magnesium",
  "zinc",
  "liver",
  "anemia",
  "cametabolism",
  "vitaminB",
];

export default function AlgorithmsSection({ algorithmResult, embedded = false }) {
  const { t } = useLang();
  const entries = ORDER.filter((k) => algorithmResult && algorithmResult[k] && algorithmResult[k].SUCCESS);

  return (
    <section
      id={embedded ? undefined : "algorithms"}
      data-testid="algorithms-section"
      className={embedded ? "" : "container-x scroll-mt-24 py-20 md:py-24"}
    >
      {!embedded && (
        <div className="flex flex-col gap-3">
          <span className="overline">{t.results.algorithms.overline}</span>
          <h2 className="text-4xl text-zinc-900 md:text-[44px]">{t.results.algorithms.title}</h2>
          <p className="max-w-2xl text-base text-zinc-600">{t.results.algorithms.subtitle}</p>
        </div>
      )}

      <div className={embedded ? "grid grid-cols-1 gap-4 xl:grid-cols-2" : "mt-10 space-y-3"}>
        {entries.map((k, i) => (
          <AlgorithmCard key={k} id={k} algo={algorithmResult[k]} idx={i} />
        ))}
      </div>

      <p className="mt-8 text-xs text-zinc-400">{t.results.disclaimer}</p>
    </section>
  );
}
